import React from 'react';

import { Common } from 'ws-scripts/modules/common';

const InProgressButtons = () => {
	const buttonClasses = 'btn btn-default btn-block btn-sm';
	return (
		<Common
			render={({ labels, sitemap }) => {
				return (
					<div className="in-progress-links-container mt-3">
						<div className="in-progress-links row hide">
							<div className="ddc-span12">
								<a
									className={`${buttonClasses} dialog`}
									href={sitemap.get(
										'INVENTORY_LEAD_SCHEDULE'
									)}
									target="_self"
								>
									{labels.get('MAKE_APPOINTMENT')}
								</a>
								<a
									className={buttonClasses}
									href={sitemap.get('DIRECTIONS_DEFAULT')}
									target="_self"
								>
									{labels.get('GET_DIRECTIONS')}
								</a>
							</div>
						</div>
					</div>
				);
			}}
		/>
	);
};

InProgressButtons.propTypes = {};

export default InProgressButtons;



// WEBPACK FOOTER //
// ./src/components/InProgressButtons.jsx